// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__267aD","left":"StickyBox_left__3Lgls","right":"StickyBox_right__NpemC"};